import React, { useEffect } from 'react';
import './Get15TPCModal.css';

interface Get15TPCModalProps {
  isOpen: boolean;
  onClose: () => void;
  onOpenLogin?: () => void;
}

const Get15TPCModal: React.FC<Get15TPCModalProps> = ({ isOpen, onClose, onOpenLogin }) => {
  // Close modal on escape key
  useEffect(() => {
    const handleEscape = (e: KeyboardEvent) => {
      if (e.key === 'Escape' && isOpen) {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener('keydown', handleEscape);
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }

    return () => {
      document.removeEventListener('keydown', handleEscape);
      document.body.style.overflow = 'unset';
    };
  }, [isOpen, onClose]);

  const handleSignUp = () => {
    if (onOpenLogin) {
      onClose(); // Close this modal first
      onOpenLogin(); // Then open the login modal
    }
  };

  if (!isOpen) return null;

  return (
    <div className="get15tpc-modal-overlay" onClick={(e) => {
      if (e.target === e.currentTarget) {
        onClose();
      }
    }}>
      <div className="get15tpc-modal-content">
        <button
          className="close-get15tpc-modal-btn"
          onClick={onClose}
        >
          ×
        </button>

        <div className="modal-body">
          <div className="get15tpc-step">
            <h2 className="step-title">Get 15 $TPC</h2>
            <ul className="step-content-list">
              <li>Create an account and receive 10 $TPC instantly.</li>
              <li>Earn 5 $TPC for every friend you refer when they place their first parlay.</li>
            </ul>
          </div>
        </div>

        <div className="step-navigation">
          <button className="sign-up-btn" onClick={handleSignUp}>
            Sign Up
          </button>
        </div>
      </div>
    </div>
  );
};

export default Get15TPCModal;
